import React, { useId } from "react";
import RankInsignia, { tierGlyph } from "../../../shared/rating/RankInsignia";
import { insigniaForValue } from "../../../shared/rating/tiers";
import styles from "./icons.module.scss";

// The start page's icons (24 grid, 2px strokes, round joins), the Golden Egg
// and the hex rank badge.
const svgProps = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" as const, strokeLinejoin: "round" as const, "aria-hidden": true };
type IconProps = { className?: string };

export const Crown = () => (<svg {...svgProps}><path d="M4 8l4 3.5L12 5l4 6.5L20 8l-1.6 10H5.6L4 8z" fill="currentColor" fillOpacity="0.25" /><path d="M6 21h12" /></svg>);
export const Arrow = () => (<svg {...svgProps} strokeWidth={2.6}><path d="M5 12h14M13 6l6 6-6 6" /></svg>);
export const Trophy = () => (<svg {...svgProps}><path d="M7 4h10v5a5 5 0 01-10 0V4zM7 6H4v2a3 3 0 003 3M17 6h3v2a3 3 0 01-3 3M12 14v4M8 20h8" /></svg>);
export const Doors = () => (<svg {...svgProps}><rect x="3" y="4" width="8" height="16" rx="1.5" /><rect x="13" y="4" width="8" height="16" rx="1.5" /><path d="M9 12h.01M15 12h.01" /></svg>);
export const Globe = () => (<svg {...svgProps}><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3.2 3 14.8 0 18M12 3c-3 3.2-3 14.8 0 18" /></svg>);
export const Lock = () => (<svg {...svgProps}><rect x="5" y="10" width="14" height="10" rx="2" /><path d="M8 10V7a4 4 0 018 0v3" /></svg>);
export const Keys = () => (<svg {...svgProps}><rect x="2" y="6" width="20" height="12" rx="2" /><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10" /></svg>);
export const FullExit = () => (<svg {...svgProps}><path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" /></svg>);
export const Full = () => (<svg {...svgProps}><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" /></svg>);
export const Play = () => (<svg {...svgProps}><path d="M7 5l12 7-12 7V5z" fill="currentColor" fillOpacity="0.25" /></svg>);
export const Plus = () => (<svg {...svgProps}><path d="M12 5v14M5 12h14" /></svg>);
export const Chev = ({ className }: IconProps) => (<svg {...svgProps} className={className}><path d="M9 6l6 6-6 6" /></svg>);
export const ChevL = () => (<svg {...svgProps}><path d="M15 6l-6 6 6 6" /></svg>);
export const Gear = () => (<svg {...svgProps}><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" /></svg>);
export const Grid = () => (<svg {...svgProps}><rect x="4" y="4" width="6" height="6" rx="1.5" /><rect x="14" y="4" width="6" height="6" rx="1.5" /><rect x="4" y="14" width="6" height="6" rx="1.5" /><rect x="14" y="14" width="6" height="6" rx="1.5" /></svg>);
export const News = () => (<svg {...svgProps}><path d="M4 5h13v14H6a2 2 0 01-2-2V5zM17 9h3v8a2 2 0 01-2 2M8 9h5M8 13h5M8 16h3" /></svg>);
export const Bars = () => (<svg {...svgProps}><path d="M5 20V11M12 20V5M19 20v-6" /></svg>);
export const History = () => (<svg {...svgProps}><path d="M3 12a9 9 0 109-9 9 9 0 00-6.4 2.6L3 8" /><path d="M3 3v5h5M12 7v5l3 2" /></svg>);
export const Person = () => (<svg {...svgProps}><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5a7.5 7.5 0 0115 0" /></svg>);
export const Info = () => (<svg {...svgProps}><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>);
export const Help = () => (<svg {...svgProps}><circle cx="12" cy="12" r="9" /><path d="M9.5 9.5a2.5 2.5 0 014.6 1.3c0 1.7-2.1 2.2-2.1 3.4M12 17h.01" /></svg>);
export const Sound = () => (<svg {...svgProps}><path d="M4 10v4h4l5 4V6L8 10H4zM16.5 9a4 4 0 010 6M19 6.5a7.5 7.5 0 010 11" /></svg>);
export const Vibrate = () => (<svg {...svgProps}><rect x="8" y="4" width="8" height="16" rx="1.5" /><path d="M4 9v6M20 9v6M1.5 10.5v3M22.5 10.5v3" /></svg>);
export const Music = () => (<svg {...svgProps}><path d="M9 18V6l11-2v12" /><circle cx="6.5" cy="18" r="2.5" /><circle cx="17.5" cy="16" r="2.5" /></svg>);

// A Golden Egg (the shop currency): a small glossy gold egg with a dark rim so
// it reads on the gold button.
export function GoldenEgg({ className }: IconProps) {
  const id = "egg" + useId().replace(/[^a-zA-Z0-9_-]/g, "");
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <radialGradient id={id} cx="0.36" cy="0.32" r="0.8">
          <stop offset="0" stopColor="#fffbe2" />
          <stop offset="0.35" stopColor="#ffe680" />
          <stop offset="0.72" stopColor="#ffbe2e" />
          <stop offset="1" stopColor="#d27f08" />
        </radialGradient>
      </defs>
      <path d="M12 2c-3.9 0-7.4 6.1-7.4 11.4a7.4 7.4 0 0014.8 0C19.4 8.1 15.9 2 12 2z" fill={`url(#${id})`} stroke="#6b3f00" strokeWidth="1.3" />
      <path d="M9.2 6.4c-1.3 1.6-2.1 3.7-2.3 5.6" fill="none" stroke="#fff" strokeOpacity="0.9" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

const hexAt = (cx: number, cy: number, r: number, k: number) => {
  const a = (Math.PI / 180) * (60 * k - 90);
  return `${(cx + r * Math.cos(a)).toFixed(1)},${(cy + r * Math.sin(a)).toFixed(1)}`;
};
// The cut edge of the hexagon from Platinum up: one facet per side, lit from the
// top left (the sides in order from the top corner, clockwise).
const FACETS = ["rgba(255,255,255,0.2)", "rgba(0,0,0,0.1)", "rgba(0,0,0,0.3)", "rgba(0,0,0,0.2)", "rgba(255,255,255,0.05)", "rgba(255,255,255,0.34)"];
const hexPts = (cx: number, cy: number, r: number) =>
  Array.from({ length: 6 }, (_, k) => {
    const a = (Math.PI / 180) * (60 * k - 90);
    return `${(cx + r * Math.cos(a)).toFixed(1)},${(cy + r * Math.sin(a)).toFixed(1)}`;
  }).join(" ");

// Blend a #rrggbb colour toward white (t > 0) or black (t < 0).
function shade(hex: string, t: number): string {
  const n = hex.replace("#", "");
  const to = t > 0 ? 255 : 0;
  const k = Math.abs(t);
  const ch = [0, 2, 4].map((i) => Math.round(parseInt(n.slice(i, i + 2), 16) * (1 - k) + to * k));
  return `rgb(${ch[0]}, ${ch[1]}, ${ch[2]})`;
}

// ---------- the rank badge ----------
// What a rank badge shows:
//  - "ranked": your tier and step, with a track around it for the way to the next step.
//  - "placing": no rank yet, the track counts the placement matches played.
//  - "locked": signed out.
//  - "blank": still loading.
export type BadgeLook =
  | { kind: "ranked"; color: string; pct: number; pips: number; value: number }
  | { kind: "placing"; pct: number }
  | { kind: "locked" }
  | { kind: "blank" };

const GREY = { stops: ["#3b4760", "#2a3447", "#1b2333"], ink: "#8ea3bd" };

// The track around a badge: a hexagon outline that fills clockwise from the top
// corner. Sharp corners and square ends, and its START is cut straight down
// through the top corner (a plain square end there would sit at the edge's slant):
// the fill gains the little wedge outside the corner and loses the one inside.
function Track({ r, w, pct, color, id }: { r: number; w: number; pct: number; color: string; id: string }) {
  const cx = 32, cy = 32, vy = cy - r;
  const k = w / 2;
  // the first edge runs down to the right at 30 degrees; (0.5, -0.866) is its outward normal
  const outerCap = `${(cx + k * 0.5).toFixed(2)},${(vy - k * 0.866).toFixed(2)}`;
  const innerCap = `${(cx - k * 0.5).toFixed(2)},${(vy + k * 0.866).toFixed(2)}`;
  const outerTip = `${cx},${(vy - w / Math.sqrt(3)).toFixed(2)}`;
  const innerTip = `${cx},${(vy + w / Math.sqrt(3)).toFixed(2)}`;
  const top = `${cx},${vy}`;
  const full = pct >= 99.5;
  return (
    <>
      <polygon points={hexPts(cx, cy, r)} fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth={w} strokeLinejoin="miter" />
      {full && <polygon points={hexPts(cx, cy, r)} fill="none" stroke={color} strokeWidth={w} strokeLinejoin="miter" />}
      {!full && pct > 0 && (
        <>
          <defs>
            <clipPath id={id}><path clipRule="evenodd" d={`M-8 -8H72V72H-8Z M${top} L${innerCap} L${innerTip} Z`} /></clipPath>
          </defs>
          <polygon points={hexPts(cx, cy, r)} fill="none" stroke={color} strokeWidth={w} strokeLinejoin="miter" strokeLinecap="butt" pathLength={100} strokeDasharray={`${pct} 100`} clipPath={`url(#${id})`} />
          <polygon points={`${top} ${outerCap} ${outerTip}`} fill={color} />
        </>
      )}
    </>
  );
}

// The game's rank badge: a filled hexagon in the tier's colour. Bronze, Silver
// and Gold carry one chevron per step (I, II, III); from Platinum up the hexagon
// carries the tier's own icon from the rank ladder (shared/rating/RankInsignia:
// the speed dashes, the stone, the star ring, crowned for Wormlord), in dark ink.
export function RankBadge({ look, className }: { look: BadgeLook; className?: string; inner?: number }) {
  const g = "rb" + useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const ranked = look.kind === "ranked";
  const stops = ranked ? [shade(look.color, 0.45), look.color, shade(look.color, -0.32)] : GREY.stops;
  const ink = ranked ? shade(look.color, -0.78) : GREY.ink;
  const pct = look.kind === "ranked" || look.kind === "placing" ? Math.max(0, Math.min(100, look.pct)) : 0;
  const pips = ranked ? look.pips : 0;
  const ins = ranked ? insigniaForValue(look.value) : null;
  const glyph = ins ? tierGlyph(ins.tierIndex, pips, g + "-i") : null;
  // The dashes and the stone are slight drawings: they are set larger than the star rings.
  const gs = ins && ins.tierIndex <= 4 ? 52 : 38;
  // The climb after Gold: a cut edge from Platinum, and from Diamond a band of
  // light crossing the badge and the icon's glints twinkling.
  const tier = ins ? ins.tierIndex : 0;
  const cut = tier >= 3, lit = tier >= 4;
  return (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true" style={{ overflow: "visible" }}>
      <defs>
        <linearGradient id={g} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={stops[0]} />
          <stop offset="0.55" stopColor={stops[1]} />
          <stop offset="1" stopColor={stops[2]} />
        </linearGradient>
        {/* the icons' fill: one flat ink */}
        {lit && <clipPath id={g + "-h"}><polygon points={hexPts(32, 32, 22.5)} /></clipPath>}
        <linearGradient id={g + "-i"}><stop offset="0" stopColor={ink} /><stop offset="1" stopColor={ink} /></linearGradient>
      </defs>
      <Track r={30} w={3} pct={pct} color={ranked ? look.color : "#dfe5f0"} id={g + "-c"} />
      <polygon points={hexPts(32, 32, 22.5)} fill={`url(#${g})`} />
      {cut && FACETS.map((f, k) => (
        <polygon key={k} points={`${hexAt(32, 32, 22.5, k)} ${hexAt(32, 32, 22.5, k + 1)} ${hexAt(32, 32, 18, k + 1)} ${hexAt(32, 32, 18, k)}`} fill={f} />
      ))}
      <polygon points={hexPts(32, 32, 22.5)} fill="none" stroke={ranked ? "rgba(255,255,255,0.55)" : "rgba(255,255,255,0.18)"} strokeWidth="1" />
      {look.kind === "locked" && <path d="M25.5 31h13v10h-13zM28.5 31v-3a3.5 3.5 0 017 0v3" fill="none" stroke={ink} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />}
      {look.kind === "placing" && <path d="M28 27.5a4.2 4.2 0 017.9 2c0 2.8-3.6 3.2-3.6 5.8M32.3 40.5h.01" fill="none" stroke={ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />}
      {glyph && (
        <svg className={lit ? styles.twinkle : undefined} x={32 - gs / 2} y={31.5 - gs / 2} width={gs} height={gs} viewBox="0 0 100 100" style={{ "--c1": ink, overflow: "visible" } as React.CSSProperties}>
          {glyph}
          {/* Master and Wormlord: a soft shine going round the ring (the ring is ringStar's: centre 50,52, radius 26).
              A blurred spot of light turns about the centre and only shows where the ring is. */}
          {tier >= 5 && (
            <>
              <defs>
                <mask id={g + "-m"} maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
                  <circle cx="50" cy="52" r="26" fill="none" stroke="#fff" strokeWidth="8" />
                </mask>
                <radialGradient id={g + "-o"}>
                  <stop offset="0" stopColor="#fff" stopOpacity="0.42" />
                  <stop offset="0.45" stopColor={shade(look.kind === "ranked" ? look.color : "#fff", 0.5)} stopOpacity="0.2" />
                  <stop offset="1" stopColor="#fff" stopOpacity="0" />
                </radialGradient>
              </defs>
              <g mask={`url(#${g}-m)`}>
                <ellipse className={styles.orbit} cx="50" cy="26" rx="24" ry="13" fill={`url(#${g}-o)`} />
              </g>
            </>
          )}
        </svg>
      )}
      {lit && (
        <g clipPath={`url(#${g}-h)`}>
          <g transform="skewX(-22)">
            <g className={styles.sheen} style={{ animationDelay: `${-(tier - 4) * 1.3 - pips * 0.4}s` }}>
              <rect x={4} y={6} width={7} height={52} fill="rgba(255,255,255,0.42)" />
              <rect x={14} y={6} width={2.5} height={52} fill="rgba(255,255,255,0.3)" />
            </g>
          </g>
        </g>
      )}
      {ranked && !glyph && pips <= 1 && <path d="M23 30l9 5.5 9-5.5" fill="none" stroke={ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />}
      {ranked && !glyph && pips === 2 && <path d="M23 27l9 5.5 9-5.5M23 34.5l9 5.5 9-5.5" fill="none" stroke={ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />}
      {ranked && !glyph && pips >= 3 && <path d="M23.5 24l8.5 5 8.5-5M23.5 30.5l8.5 5 8.5-5M23.5 37l8.5 5 8.5-5" fill="none" stroke={ink} strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />}
    </svg>
  );
}

// The other design tried: the rank ladder's insignia on its own, inside the same
// track. Not used by the game: kept for comparison on /debug/rank-badges.
export function RankBadgeInsignia({ look, className, inner = 34 }: { look: BadgeLook; className?: string; inner?: number }) {
  const g = "ri" + useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const ranked = look.kind === "ranked";
  const pct = look.kind === "ranked" || look.kind === "placing" ? Math.max(0, Math.min(100, look.pct)) : 0;
  return (
    <span className={className} style={{ position: "relative", display: "grid", placeItems: "center" }} aria-hidden="true">
      <svg viewBox="0 0 64 64" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", overflow: "visible" }}>
        <Track r={29} w={4} pct={pct} color={ranked ? look.color : "#dfe5f0"} id={g} />
      </svg>
      {ranked && <RankInsignia value={look.value} size={inner} />}
      {(look.kind === "placing" || look.kind === "locked") && <RankInsignia rating={null} placeholder size={Math.round(inner * 0.9)} />}
    </span>
  );
}
